import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import AuthShell from "@/pages/auth/AuthShell";
import { Field, SubmitButton, FormError } from "@/components/forms/Field";
import { useAuth, homeFor } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await login(email, password);
      const next = params.get("next");
      navigate(next && next.startsWith("/") ? next : homeFor(user), { replace: true });
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="Welcome back" subtitle="Sign in to continue your child's career discovery."
      footer={<>New to Disha? <Link to="/signup" className="font-semibold text-ds-plum link-underline" data-testid="login-register-link">Create a parent account</Link></>}>
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <Field id="email" label="Registered e-mail id" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} testId="login-email-input" />
        <Field id="password" label="Password" type="password" autoComplete="current-password" required value={password} onChange={(e) => setPassword(e.target.value)} testId="login-password-input" />
        <div className="flex justify-end -mt-2">
          <Link to="/forgot-password" className="text-sm font-semibold text-ds-plum link-underline" data-testid="login-forgot-password-link">Forgot password?</Link>
        </div>
        <FormError message={error} testId="login-error" />
        <SubmitButton busy={busy} testId="login-submit-button">Sign in</SubmitButton>
        <p className="rounded-xl bg-ds-creamalt px-4 py-3 text-[13px] text-ds-inksoft leading-relaxed" data-testid="login-session-note">For your security, you are signed out automatically after 10 minutes of inactivity, and an account can be signed in on one device at a time.</p>
      </form>
    </AuthShell>
  );
}
